import { mapActions } from 'vuex';
import { loadScript } from '@/utils/helpers';
/*
  Use this component as <captcha :key="parentVar"></captcha>
  and update var on error, so it rerenders properly.
 */
export default {
  props: {
    modelValue: String,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      key: '',
      widgetId: undefined,
    };
  },
  computed: {
    styleModifiers() {
      return {
        transform: 'scale(0.95)',
      };
    },
  },
  methods: {
    ...mapActions('user', ['getCaptchaSiteKey']),
    onSuccess(value) {
      this.$emit('update:modelValue', value);
    },
    onExpired() {
      this.$emit('update:modelValue', null);
    },
  },
  mounted() {
    const url = 'https://www.google.com/recaptcha/api.js';
    loadScript(url, 'grecaptcha').then((grecaptcha) => {
      this.getCaptchaSiteKey().then((data) => {
        this.key = data;
        grecaptcha.ready(() => {
          this.widgetId = grecaptcha.render(this.$refs.captcha, {
            sitekey: this.key,
            callback: this.onSuccess,
            'expired-callback': this.onExpired,
          });
        });
      });
    });
  },
  beforeUnmount() {
    if (window.grecaptcha && typeof this.widgetId !== 'undefined') {
      window.grecaptcha.reset(this.widgetId);
    }
  },
};
